import React from 'react';
import {ModalWrapper} from './modal-wrapper';

export interface CryptoProcessingModalProps {
  imageSrc?: string;
  transactionHash: string;
  onModalClose: () => void;
}

export const CryptoProcessingModal: React.FC<CryptoProcessingModalProps> = ({
  imageSrc,
  transactionHash,
  onModalClose,
}: CryptoProcessingModalProps) => {
  return (
    <ModalWrapper
      title="Processing your payment"
      copyPrimary={transactionHash}
      copySecondary="We are accepting the signature requested for us to process your purchase."
      withProcessingIndicator
      imageSrc={imageSrc}
      onModalClose={onModalClose}
    />
  );
};
